import { OrganizationApi } from '../../../api';
import { dispatch } from '../../../store';
import { addOrganizationPolicies } from '../../../store/slices/organization-policies.slice';
import { useContainer } from '../../useContainer';
import { useEffect } from 'react';

const useHttpGetOrganizationPublicPoliciesOnMount = () => {
    const organizationApi: OrganizationApi = useContainer(OrganizationApi);

    useEffect(() => {
        const { exec, abort } = organizationApi.getOrganizationPublicPolicies({
            onSuccess: res => dispatch(addOrganizationPolicies(res.body)),
            onError: error => error,
        });
        exec();
        return abort;
    }, []);
};

export default useHttpGetOrganizationPublicPoliciesOnMount;
